import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import _ from 'lodash'

import PkgStatus from '../PkgStatus'

import { supportLanguageList } from '../../data/supportLanguage'
import styles from '../../styles/PackageInfoCard.module.css'

import { PackageInfo } from '../../types'

const languageList = require('language-list')()

/**
 * @description props으로 받은 패키지의 정보를 구성하는 component.
 * @param { name, status, thumbanil, description } props 보여줄 패키지의 정보 데이터
 */
const PackageInfoCard = ({ packageInfo }: { packageInfo: PackageInfo }) => {
  const selectedLang =
    packageInfo.packType === 'PLUS' &&
    supportLanguageList.find((lang) => lang.code === packageInfo.textLang)

  return (
    <div className={styles.wrapper}>
      <p className={styles.head}>
        <FormattedMessage
          id={'PackageInfo.title'}
          defaultMessage={'Pack Information'}
        />
      </p>
      <div className={styles.content}>
        <img src={packageInfo.thumbnail.url} alt="thumb nail" />
        <div className={styles.infobox}>
          <div className={styles.row}>
            <label>
              <FormattedMessage id={'PackageInfo.name.en'} />
            </label>
            <div>{packageInfo.name.en}</div>
          </div>
          <div className={styles.row}>
            <label>
              <FormattedHTMLMessage id={'PackageInfo.description'} />
            </label>
            <div>{packageInfo.description.en}</div>
          </div>
          {packageInfo.packType === 'PLUS' && (
            <div className={styles.row}>
              <label>
                <FormattedMessage id={'PackageInfo.lang'} />
              </label>
              <div>
                {packageInfo.textLang === 'IMAGE_ONLY' && (
                  <FormattedMessage id="Upload.PkgCreation.createPack.packLanguage.imageOnly" />
                )}
                {selectedLang && `${selectedLang.emoji} ${selectedLang.name}`}
              </div>
            </div>
          )}
          <div className={styles.row}>
            <label>
              <FormattedMessage id={'PackageInfo.status'} />
            </label>
            <div>
              <PkgStatus status={packageInfo.status} isMyPkg={true} />
            </div>
          </div>
          <div className={styles.row}>
            <label>
              <FormattedMessage id={'PackageInfo.type'} />
            </label>
            {packageInfo.packType ? (
              <div
                className={
                  packageInfo.packType === 'PLUS'
                    ? styles.plusPackLabel
                    : styles.basicPackLabel
                }
              >
                <FormattedMessage id={`Guide.nav.${packageInfo.packType}`} />
              </div>
            ) : (
              <FormattedMessage id="Upload.PkgCreation.createPack.packType.undefined" />
            )}
          </div>
          <div className={styles.rowTag}>
            <label>
              <FormattedHTMLMessage id={'PackageInfo.keyText'} />
            </label>
            <div className={styles.keywordBoxWrapper}>
              {packageInfo.keyTexts?.map((key) => (
                <div key={key} className={styles.keywordBox}>
                  #{key}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default PackageInfoCard
